module.exports = __webpack_public_path__ + "static/media/candidate.cfe98ed4.svg";